import React from 'react';
import './App.css';




export default function NoPage() {

  return (
    <div className="appContainer">
      <section className="heroSection">
        <h1 style={{ fontSize: '4rem', marginBottom: '20px' }}>404</h1>
        <p style={{ fontSize: '1.5rem' }}>Sorry, the page you're looking for doesn't exist.</p>
      </section>
    </div>
  );
}
